import { defineStore } from 'pinia';

export const useMainStore = defineStore('main', {
	state: () => ({
		solution: 'mba',
		site: null,
		isLoggedIn: false,
		loginData: null,
		notificationMessages: []
	}),

	actions: {
		setSiteData(data) {
			this.site = data;

			//maintenance mode
			if (this.site.maintenance) {
				const now = new Date();
				const notificationUntil = new Date(this.site.maintenance.showGobalNotificationUntil);
				if (
					this.site.maintenance.globalNotification != null &&
					notificationUntil > now
				) {
					this.setNotificationMessage(this.site.maintenance.globalNotification, this.site.maintenance.globalNotificationLink);
				}
			}
		},
		setLoggedIn(value, data) {
			this.isLoggedIn = !!value;
			this.loginData = value ? data : null;
		},
		setNotificationMessage(message, link, timeOutSecs) {
			const isDuplicate = this.notificationMessages.some(notification =>
				notification.message === message && notification.link === link
			);
			if (isDuplicate) return;
			var timeOut = null;
			if (timeOutSecs != null) {
				timeOut = new Date(Date.now() + (timeOutSecs * 1000))
			}
			this.notificationMessages.push({
				message: message,
				link: link,
				timeout: timeOut
			});
			if (timeOutSecs != null) {
				setTimeout(() => {
					const currentTime = new Date();
					for (let i = this.notificationMessages.length - 1; i >= 0; i--) {
					  const message = this.notificationMessages[i];
					  if (message.timeout !== null && message.timeout <= currentTime) {
						this.notificationMessages.splice(i, 1);
					  }
					}
				}, timeOutSecs * 1000);
			}
		}
	},
});
